/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetExamArticleDto
 */
export interface GetExamArticleDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamArticleDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamArticleDto
     */
    articleId: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamArticleDto
     */
    type: GetExamArticleDtoTypeEnum;
}


/**
 * @export
 */
export const GetExamArticleDtoTypeEnum = {
    Doctor: 'Doctor',
    Psychologist: 'Psychologist'
} as const;
export type GetExamArticleDtoTypeEnum = typeof GetExamArticleDtoTypeEnum[keyof typeof GetExamArticleDtoTypeEnum];


/**
 * Check if a given object implements the GetExamArticleDto interface.
 */
export function instanceOfGetExamArticleDto(value: object): value is GetExamArticleDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('articleId' in value) || value['articleId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetExamArticleDtoFromJSON(json: any): GetExamArticleDto {
    return GetExamArticleDtoFromJSONTyped(json, false);
}

export function GetExamArticleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamArticleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'articleId': json['articleId'],
        'type': json['type'],
    };
}

export function GetExamArticleDtoToJSON(value?: GetExamArticleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'articleId': value['articleId'],
        'type': value['type'],
    };
}

